import "./css/app.scss";
import "./ts/neto.js";

import lazyLoad from "./ts/lazyLoad";
import loadSprite from "./ts/loadSprite";
import { addEvent, appHeight, heightChange } from "./ts/utils";
import accordian from "./ts/accordian";
import mobMenu from "./ts/mobMenu";
import descMenu from "./ts/descMenu";
import stickyHeader from "./ts/stickyHeader";

import readMore from "./ts/readmore";
import cartLine from "./ts/cartLine";
import sidebar from "./ts/sidebar";
import cartValidation from "./ts/cartValidation";
import showHide from "./ts/showHidePagination";
import searchFocus from "./ts/searchFocus";
import popupHover from "./ts/popupHover";
import filterToggle from "./ts/filterToggle";
import popupGalleryLazy from "./ts/popupGalleryLazy";
import "./ts/popResets";

const page = document.body.id;

addEvent();
appHeight();
heightChange();
loadSprite.init();
accordian.init();
mobMenu.init();
descMenu.init();
stickyHeader.init();
readMore.init();
searchFocus.init();
popupHover.init();

if (page !== "n_checkout") {
  import("./ts/slider").then(({ default: slider }) => {
    slider.init();
  });
}

if (page === "n_home") {
  lazyLoad.init();
}

if (page === "n_category") {
  sidebar.init();
  filterToggle.init();
}

if (page === "n_product") {
  cartLine.init();
  showHide.init();
  popupGalleryLazy.init();
}

if (page === "n_checkout") {
  cartValidation.init();
  cartLine.init();
}
